import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { calculateTimeLeft } from "src/utils";
import { getDataHandlerWithToken, getDataHandlerWithTokenAuthSection } from "src/apiconfig/service";
import { io } from "socket.io-client";
import ApiConfig, { WebSocketUrl } from "src/apiconfig/apiconfig";
export const AuthContext = createContext();

const setSession = (accessToken) => {
  if (accessToken) {
    sessionStorage.setItem("creatturAccessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    sessionStorage.removeItem("creatturAccessToken");
    sessionStorage.removeItem("userType");
    delete axios.defaults.headers.common.Authorization;
  }
};

function checkLogin(token) {
  const accessToken = window.sessionStorage.getItem("adminToken")
    ? window.sessionStorage.getItem("adminToken")
    : token;
  return accessToken ? true : false;
}

export default function AuthProvider(props) {
  const [isLogin, setIsLogin] = useState(checkLogin());
  const [userData, setUserData] = useState({});
  const [endTime, setEndtime] = useState();
  const [counting, setCounting] = useState([]);
  const [timeLeft, setTimeLeft] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [socket, setSocket] = useState(null);

  const getProfileData = async () => {
    try {
      const res = await getDataHandlerWithToken("getAdminProfile");
      console.log("profilellelele", res?.data?.user?.user_type);
      if (res) {
        setUserData(res);
        sessionStorage.setItem("userType", res?.data?.user?.user_type);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };




  const getSupportCounting = async () => {
    try {
      const res = await getDataHandlerWithTokenAuthSection("getChatList");
      console.log("dasfasddf", res.responseCode);
      if (res.responseCode === 200) {
        // setUserData(res.result);
        // sessionStorage.setItem("userType", res.result?.userType);
        setCounting(res?.chatData?.filter((item) => item?.chatStatus !== "CLOSED"))
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    const token = sessionStorage.getItem("adminToken");
    if (!token) return;
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    getProfileData();
    // Chat list API is not allowed for clinic; a 403 there used to clear the whole session via the global interceptor.
    const role = sessionStorage.getItem("userType");
    if (role && role !== "clinic") {
      getSupportCounting();
    }
  }, [sessionStorage.getItem("adminToken")]);

  useEffect(() => {
    if (endTime) {
      const timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft(endTime));
      }, 1000);
      return () => clearTimeout(timer);
    }
  });


  // useEffect(() => {
  //   // Connect to the WebSocket server
  //   const socketInstance =io(WebSocketUrl, {
  //    transports:["polling"],
  //    reconnection:5
  //  });


  //   // Handle the connection open event
  //   socketInstance.on("connect", () => {
  //      const socketId = socketInstance.id;
  //      console.log("Socket rideSocket connect", socketId);
  //    });




  //   // Handle connection errors
  //   socketInstance.on('connect_error', (error) => {
  //     console.error('WebSocket connection error: ', error);
  //   });


  //   // Handle the connection close event
  //   socketInstance.on('disconnect', () => {
  //     console.log('WebSocket disconnected');
  //   });


  //   // Save the socket instance
  //   setSocket(socketInstance);


  //   // Clean up on component unmount
  //   return () => {
  //     socketInstance.disconnect();
  //   };


  //  }, []);

  let data = {
    userLoggedIn: isLogin,
    userData,
    counting,
    setEndtime,
    isLoading,
    timeLeft,
    userLogIn: (type, data) => {
      setSession(data);
      setIsLogin(type);
    },
    setIsLogin,
    getProfileData: () => {
      getProfileData();
    },
    checkLogin: (token) => {
      checkLogin(token);
    },
    socket: socket,
  };

  return (
    <AuthContext.Provider value={data}>{props.children}</AuthContext.Provider>
  );
}
